import imagesLoaded from 'imagesLoaded'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI from './photoswipe-ui'
import {
  find,
  findParentByClass,
  addClass,
  // removeClass,
} from '../common/elements'
import { addListener } from '../common/events'
import lightboxHTML from '../includes/lightbox-html'

const Lightbox = opts => {
  // setup defaults
  let options
  let lightboxes = []
  let transformProperty
  const transforms = [
    'transform',
    'msTransform',
    'webkitTransform',
    'mozTransform',
    'oTransform',
  ]

  const mergeDefaults = (opts = {}) => {
    const defaults = {
      lightboxSelector: '.wwp3-js-lightbox',
      itemSelector: '.wwp3-js-lightbox__slide',
    }

    for (let prop in defaults) {
      if (!opts[prop]) {
        opts[prop] = defaults[prop]
      }
    }
    return opts
  }

  const parseLightboxElement = element => {
    const linkEl = element.children[0] // <a> element
    const img = find('img', element)[0]

    console.log(img.naturalWidth, img.naturalHeight)

    return {
      msrc: find('.wwp3-js-lightbox-thumbnail', element)[0].src,
      src: linkEl.getAttribute('href'),
      w: img.naturalWidth,
      h: img.naturalHeight,
      title: '',
      vGap: {
        top: 90,
        bottom: 40,
      },
      element,
    }
  }

  const closest = (el, fn) => el && (fn(el) ? el : closest(el.parentNode, fn))

  const openPhotoSwipe = (
    index,
    lightbox,
    disableAnimation = false,
    fromURL
  ) => {
    const pswpElement = document.querySelectorAll('.pswp')[0]

    const lightboxOptions = {
      galleryUID: lightbox.element.getAttribute('data-lightbox-id'),
      getThumbBoundsFn: idx => {
        // See Options -> getThumbBoundsFn section of documentation for more info
        const thumbnail = lightbox.items[idx].element.getElementsByTagName(
          'img'
        )[0]
        const pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop
        const rect = thumbnail.getBoundingClientRect()

        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width,
        }
      },
      addCaptionHTMLFn: (item, captionEl, isFake) => {
        if(!item.element.title) {
          captionEl.children[0].innerHTML = '';
          return false;
        }

        captionEl.children[0].innerHTML = item.element.title;
        return true;
      },
      showHideOpacity: true,
      spacing: 0,
      preloaderEl: false,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      history: false,
      preload: [1, 2],
      bgOpacity: 1,
      barsSize: {
        top: 40,
        bottom: 40,
        left: 40,
        right: 40,
      },
      // onLightboxOpen: options.onLightboxOpen,
      // onLightboxClose: options.onLightboxClose,
      closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar', 'bg'],
    }

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (lightboxOptions.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (let j = 0; j < lightbox.items.length; j += 1) {
          if (lightbox.items[j].pid === index) {
            lightboxOptions.index = j
            break
          }
        }
      } else {
        // in URL indexes start from 1
        lightboxOptions.index = parseInt(index, 10) - 1
      }
    } else {
      lightboxOptions.index = parseInt(index, 10)
    }

    // exit if index not found
    if (isNaN(lightboxOptions.index)) return

    if (disableAnimation) {
      lightboxOptions.showAnimationDuration = 0
    }

    // Pass data to PhotoSwipe and initialize it
    const lbox = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI,
      lightbox.items,
      lightboxOptions
    )
    lbox.init()
    // gallery.listen('close', onLightboxClose)
    // disable zoom
    lbox.options.maxSpreadZoom = lbox.getZoomLevel()
    lbox.options.getDoubleTapZoom = (isMouseClick, item) =>
      item.initialZoomLevel
  }

  // triggers when user clicks on thumbnail
  const onThumbnailsClick = evt => {
    evt = evt || window.event
    evt.preventDefault()

    const eTarget = evt.target || evt.srcElement

    const clickedListItem = closest(
      eTarget,
      el => el.tagName && el.tagName.toUpperCase() === 'FIGURE'
    )

    if (!clickedListItem) return false

    const index = parseInt(
      clickedListItem.getAttribute('data-lightbox-item-id'),
      10
    )

    if (index >= 0) {
      const lb = findParentByClass(clickedListItem, options.lightboxSelector)
      openPhotoSwipe(index, lightboxes[lb.getAttribute('data-lightbox-id')])
    }
    return false
  }

  const setTranslate3DTransform = (element, xPos, yPos = 0, zPos = 0) => {
    element.style[transformProperty] = `translate3d(${xPos}, ${yPos}, ${zPos})`
  }

  const getSupportedPropertyName = properties => {
    for (let i = 0; i < properties.length; i += 1) {
      if (typeof document.body.style[properties[i]] != 'undefined') {
        return properties[i]
      }
    }
    return null
  }

  const initLightboxes = () => {
    const lightBoxList = []
    const lightboxElements = find(options.lightboxSelector)
    for (let i = 0, l = lightboxElements.length; i < l; i += 1) {
      imagesLoaded(lightboxElements[i], () => {
        const items = find(options.itemSelector, lightboxElements[i])
        lightboxElements[i].setAttribute('data-lightbox-id', i)
        const lbItems = items.map((item, index) => {
          item.setAttribute('data-lightbox-item-id', index)
          addListener(item, 'click', onThumbnailsClick)
          return parseLightboxElement(item)
        })

        lightBoxList.push({
          element: lightboxElements[i],
          items: lbItems,
        })
      })
    }
    return lightBoxList
  }

  const addLightboxHTML = () => {
    const elem = document.createElement('div')
    elem.innerHTML = lightboxHTML
    addClass(elem, 'wwp3-lightbox-wrapper')
    document.body.appendChild(elem)
  }

  const init = () => {
    options = mergeDefaults(opts)
    transformProperty = getSupportedPropertyName(transforms)
    addLightboxHTML()

    imagesLoaded('.js-hero', () => {
      lightboxes = initLightboxes()
    })
  }

  // function onLightboxClose () {
  //   removeClass(find('.animate-out'), 'animate-out');
  //
  //   if(options.onLightboxClose) {
  //     options.onLightboxClose()
  //   }
  //   $.fn.fullpage.setKeyboardScrolling(true)
  // }

  init()
}

export default Lightbox



// WEBPACK FOOTER //
// src/assets/js/front-end/components/lightbox.js